<div class="send-external-email-container">

    <div class="header">
        <div>{{title}} </div>
        <fi-button
          variant="tertiary"
          tone="neutral"
          size="lg"
          [iconOnly]="true"
          (click)="closeDialog()"
        >
          <mat-icon fiButtonIcon>close</mat-icon>
          <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
        </fi-button>
    </div>

  <div class="main-container">

    <div class="main-content">
        <div class="form">
            <div class="form-title"><span fiTranslation="ACTION_LEAD_FORWARD_HEADLINE_EXTERNAL_USER_CHANGES"></span><span class="badge" fiTranslation="REQUEST_CREATE_APPOINTMENT_BADGE_EXTERNAL_ENQUIRY"></span></div>
            <div class="field-title" fiTranslation="ACTION_LEAD_FORWARD_HEADLINE_EXTERNAL_USER_CHANGES_SUBTEXT"></div>
        </div>
    </div>
  </div>

    <div class="footer">
        <button (click)="submit()" [disabled]="submitting">
            <img [src]="iconUrl" alt="Action icon">
            <span fiTranslation="BUTTON_LEAD_FORWARD_EXTERNAL_USER_CHANGES"></span>
            <span class="external" fiTranslation="External"></span>
        </button>
    </div>

</div>
